import React from 'react';
import ReactDom from 'react-dom';
import PostCodeInput from './post-code-input';
import { isValidPostcode, isValidContactName } from '../../../../Shared/Assets/utils';
import EventBus, {EventName} from '../../../../Shared/Assets/event-bus';

export default class CarConnectSection extends React.Component {
  constructor(props) {
    super(props);

    this.postcodeChanged = this.postcodeChanged.bind(this);
    this.toogleEnquiryForm = this.toogleEnquiryForm.bind(this);
    this.fetchSuburbInfo = this.fetchSuburbInfo.bind(this);

    this.state = {
      postcode: props.postcode
    };

    this.toogleEnquiryForm(false);
    this.eventBus = new EventBus();
  }

  componentDidMount() {
    this.postcodeChanged(this.props.postcode);
  }

  postcodeChanged(postcode) {
    if (isValidPostcode(postcode)) {
      this.fetchSuburbInfo(postcode);
    } else {
      this.props.formElement.Postcode.value = "";
      this.toogleEnquiryForm(false);
    }
  }

  toogleEnquiryForm(isEnabled) {
    this.props.formElement.getElementsByTagName("fieldset")[0].disabled = !isEnabled;
    this.props.formElement.btnSubmitEnquiry.disabled = !isEnabled;
  }

  fetchSuburbInfo(postcode) {
    this.setState({
      suburbInfo: ""
    }, () => {
      fetch(this.props.suburbInfoUrl + "?postcode=" + postcode)
        .then(res => res.json())
        .then(result => {
          if (result.isValidPostcode) {
            this.setState({
              suburbInfo: result.suburbInfo,
              postcode: postcode
            }, () => {
              this.props.formElement.Postcode.value = this.state.postcode;
              this.toogleEnquiryForm(true);
            });
          }
          else {
            this.setState({
              suburbInfo: "Post code is invalid"
            });
            this.toogleEnquiryForm(false);
            this.props.formElement.Postcode.value = "";

            // display default price on detail
            this.eventBus.dispatch(EventName.PostCodeChanged, {postcode: ""});
          }
        }, error => {
          console.error(error);
        });
    });
  }

  render() {
    const stateInfo = <div className="suburb-location-info">{this.state.suburbInfo}</div>;
    return (
      <div>
        <PostCodeInput postcode={this.state.postcode} placement={this.props.placement} postcodeChanged={this.postcodeChanged} />
        {stateInfo}
      </div>
    );
  }
}